import { useCallback, useEffect, useMemo, useState } from 'react';
import { Urls } from '../../services/Urls';
import services from '../../services/services';
import { decryptData } from '../../utils/encrypt';
import _ from 'underscore';
import "../../styles/sidebar.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { Sidebarmenu } from '../../utils/Sidebarmenu';
import { usePunctuality } from '../Features/Punctuality/usePunctuality';
import { useEmployeFilter } from '../../context/EmployeFilterContext';
import { callautopopulate } from '../../services/callautopop';
import useAuthStore from '../../Store/authStore';

export const useLayout = () => {
    const location = useLocation().pathname;
    const { punctuality, GetEmployeeAttandanceSummary, GetEmployeeAttandance, rowData } = usePunctuality();
    const [myProfileData, setMyProfileData] = useState({});
    const [viewProfileDialog, setViewProfileDialog] = useState(false);
    const [visible, setVisible] = useState(false);
    const [viewProfile, setViewProfile] = useState(false);
    const [showNotification, setShowNotification] = useState({ visible: location === "/" ? true : false, confirmation: false });
    const [notificationCount, setNotificationCount] = useState({ notifi: 0, punctuality: 0 });
    const [sidebarMenu] = useState(() => JSON.parse(JSON.stringify(Sidebarmenu)));
    const [menuItems, setMenuItems] = useState(() => JSON.parse(JSON.stringify(Sidebarmenu)));
    const permissions = useAuthStore((state) => state.myPermission);
    const [currentObj, setCurrentObj] = useState([])
    const [notifiData, setNotifiData] = useState([]);
    const [dataFlag, setDataFlag] = useState(false);
    const [readData, setReadData] = useState([]);
    const [notifiTypes, setNotifiTypes] = useState([]);
    const [block, setBlock] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const { setSidebarMenu, badget, setBadget } = useEmployeFilter();
    const [showTaptik, setShowTaptik] = useState(false);
    const [profileImage, setProfileImage] = useState(`${myProfileData?.image_url}?nocache=${Date.now()}`);
    const [carouselPopup, setCaroselPopup] = useState(false)
    const [isPinned, setIsPinned] = useState(false);
    const [sortableItems, setSortableItems] = useState([]);
    const [draggedItem, setDraggedItem] = useState(null);
    const [appPopup, setAppPopup] = useState({ show: false, type: "" });
    const [feedBackData, setFeedbackData] = useState([])

    useEffect(() => {
        getMyProfile();
        getNotificationData();
        callautopopulate("user_info").then((res) => {
            getNotificationbadgeData(res?.user_info?.[0]?.user_code)
        }).catch((error) => {
            console.error("error", error)
        })
    }, [])

    // useEffect(() => {
    //     if (location === '/dashboard') {
    //         const dashboardItem = menuItems.find(item => item.key === 'dashboard_li');
    //         if (dashboardItem?.innerMenu?.length > 0) {
    //             const permittedInner = dashboardItem.innerMenu.filter(inner => inner.isPermitted);
    //             navigate(permittedInner[0]?.to);
    //         }
    //     }
    // }, [menuItems, location])

    // block UI when remark not filled
    useEffect(() => {
        const content = document.getElementsByClassName("content-class");
        if (block) {
            document.body.addEventListener('touchstart', handleBlockUI, true);
            content?.[0]?.addEventListener('click', handleBlockUI, true);
            content?.[0]?.addEventListener('mousemove', handleBlockUI, true);
        }
        return () => {
            document.body.style.pointerEvents = 'auto';
            document.body.removeEventListener('click', handleBlockUI, true);
            document.body.removeEventListener('mousemove', handleBlockUI, true);
            document.body.removeEventListener('touchstart', handleBlockUI, true);
            content?.[0]?.removeEventListener('click', handleBlockUI, true);
            content?.[0]?.removeEventListener('mousemove', handleBlockUI, true);
        };
    }, [block]);

    useEffect(() => {
        GetEmployeeAttandanceSummary();
    }, [])

    useEffect(() => {
        if (punctuality?.unpunctual_days_without_remark > 0) {
            setNotificationCount((prev) => ({ ...prev, punctuality: punctuality?.unpunctual_days_without_remark }));
            GetEmployeeAttandance(null, "widget")
            setShowNotification((prev) => ({ ...prev, visible: true }));
            setBlock(true);
        } else {
            setNotificationCount((prev) => ({ ...prev, punctuality: 0 }));
            setBlock(false);
        }
    }, [punctuality])

    useEffect(() => {
        if (viewProfile) {
            const element1 = document.getElementsByClassName("content-class");
            const element2 = document.getElementsByClassName("sidebar-main-menu");
            const handleHide = () => {
                setViewProfile(false);
            }
            element1?.[0]?.addEventListener('click', handleHide, true);
            element2?.[0]?.addEventListener('click', handleHide, true);
            element2?.[1]?.addEventListener('click', handleHide, true);
            return () => {
                element1?.[0]?.removeEventListener('click', handleHide, true);
                element2?.[0]?.removeEventListener('click', handleHide, true);
                element2?.[1]?.removeEventListener('click', handleHide, true);
            };
        }
    }, [viewProfile])

    useEffect(() => {
        if (!myProfileData?.image_url) {
            setProfileImage("/assets/grey-user-icon.png");
            return;
        }
        const img = new Image();
        const url = `${myProfileData?.image_url}?cache=${Date.now()}`;
        img.onload = () => { setProfileImage(url); };
        img.onerror = () => { setProfileImage("/assets/grey-user-icon.png"); };
        img.src = url;
    }, [myProfileData])

    // block UI when remark not filled
    const handleBlockUI = () => {
        // document.body.style.pointerEvents = 'none';
        setShowNotification((prev) => ({ ...prev, visible: true }));
        const elements = document.getElementsByClassName("p-dialog-mask");
        if (elements[0]?.style?.display) {
            elements[0].style.display = "flex";
        }
        return;
    }
    // API calling for fetch profile data
    const getMyProfile = async () => {
        try {
            const res = await services.getInvokeRemote('GET', Urls('GETMYPROFILE'))
            if (res) {
                const userInfo = res?.body?.data?.myProfile_Data[0]
                const feedback = res?.body?.data?.e360_Values || []
                const horizontalRowObj = {};
                let runningTotal = 0;
                feedback?.forEach((item) => {
                    const val = Number(item?.feedback_value || 0);
                    horizontalRowObj[item?.feedback_type] = val;
                    runningTotal += val;
                });
                const surveyAvg = feedback?.length > 0 ? (runningTotal / feedback.length).toFixed(2) : "";
                horizontalRowObj["survey_avg"] = surveyAvg;
                const tableValue = [horizontalRowObj];
                const dynamicColumns = feedback?.map((item) => ({
                    field: item?.feedback_type,
                    header: item?.feedback_type,
                    description: item?.feedback_descr
                }));
                setFeedbackData({ dynamicColumns, tableValue, surveyAvg })
                setMyProfileData(userInfo);
            }
        } catch (err) {
            console.error(err);
        }
    }

    // API calling for get notification
    const getNotificationData = async () => {
        setDataFlag(false);
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETBROADCASTNOTIFICATION"), { is_app: false });
            if (res) {
                const data = res?.body?.data?.notification_get;
                const unRead = _.filter(data, { is_read: false })
                const read = _.filter(data, { is_read: true })
                setNotifiTypes(res?.body?.data?.notification_types);
                setReadData(read);
                setNotifiData(unRead);
                setNotificationCount((prev) => ({ ...prev, notifi: unRead?.length }));
                setDataFlag(true);
                if (!_.isEmpty(unRead) && location.includes("dashboard")) {
                    setShowNotification((prev) => ({ ...prev, visible: true }));
                }
            }
        } catch (error) {
            console.error(error);
        }

    }

    // API calling for logout
    const handleLogout = async () => {
        const payload = {
            token: decryptData(sessionStorage.getItem("token"))
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('LOGOUTME'), payload);
            if (res.body.error_status === false) {
                sessionStorage.clear()
                window.location.reload()
                setVisible(false)
            } else {
                setVisible(false)
                console.error("error in logging out", res.body.message);
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    // get permission and manage badge count
    useEffect(() => {
        const updateMenuItems = async () => {
            const baseMenu = JSON.parse(JSON.stringify(Sidebarmenu));
            const updatedMenuItems = await Promise.all(
                baseMenu.map(async (value) => {
                    const currentRefId = value?.id ? JSON.parse(value.id) : null;
                    const resourceKey = currentRefId?.data;
                    const data = _.findWhere(permissions, { resource_key: resourceKey });
                    let isPermitted = false;
                    let isDisabled = false;
                    if (data === undefined || !data?.is_active) {
                        isPermitted = false;
                    } else {
                        isPermitted = true;
                        if (!data.is_editable) isDisabled = true;
                    }
                    const notificationArray = badget[resourceKey] || [];
                    const notificationCount = notificationArray?.length > 0 ? notificationArray[0]?.counts || 0 : 0;
                    const updatedInnerMenu = value.innerMenu
                        ? await Promise.all(
                            value.innerMenu.map(async (innerItem) => {
                                const innerRefId = innerItem?.id ? JSON.parse(innerItem.id) : null;
                                const innerResourceKey = innerRefId?.data;
                                const innerData = _.findWhere(permissions, { resource_key: innerResourceKey });
                                let innerIsPermitted = false;
                                let innerIsDisabled = false;
                                if (innerResourceKey === "experience_center_tab") {
                                    innerIsPermitted = true;
                                } else if (innerData === undefined || !innerData?.is_active) {
                                    innerIsPermitted = false;
                                } else {
                                    innerIsPermitted = true;
                                    if (!innerData.is_editable) innerIsDisabled = true;
                                }
                                const innerNotificationArray = badget[innerResourceKey] || [];
                                const innerNotificationCount = innerNotificationArray?.length > 0 ? innerNotificationArray[0]?.counts || 0 : 0;

                                // Process subMenus if they exist
                                const updatedSubMenu = innerItem.subMenu
                                    ? await Promise.all(
                                        innerItem.subMenu.map(async (subItem) => {
                                            const subRefId = subItem?.id ? JSON.parse(subItem.id) : null;
                                            const subResourceKey = subRefId?.data;
                                            const subData = _.findWhere(permissions, { resource_key: subResourceKey });
                                            let subIsPermitted = false;
                                            let subIsDisabled = false;
                                            if (subData === undefined || !subData?.is_active) {
                                                subIsPermitted = false;
                                            } else {
                                                subIsPermitted = true;
                                                if (!subData.is_editable) subIsDisabled = true;
                                            }
                                            const subNotificationArray = badget[subResourceKey] || [];
                                            const subNotificationCount = subNotificationArray?.length > 0 ? subNotificationArray[0]?.counts || 0 : 0;

                                            return {
                                                ...subItem,
                                                isPermitted: subIsPermitted,
                                                isDisabled: subIsDisabled,
                                                ...(subNotificationCount > 0 && { notification_count: subNotificationCount }),
                                            };
                                        })
                                    )
                                    : [];

                                const subMenuNotificationSum = updatedSubMenu
                                    .filter(item => item.isPermitted && item.notification_count)
                                    .reduce((sum, item) => sum + (item.notification_count || 0), 0);

                                const totalInnerNotificationCount = innerNotificationCount + subMenuNotificationSum;

                                let isInnerPermittedFinal = innerIsPermitted;
                                if (!isInnerPermittedFinal && updatedSubMenu.length > 0) {
                                    isInnerPermittedFinal = updatedSubMenu.some(item => item.isPermitted);
                                }

                                const firstPermittedSubPath = updatedSubMenu.find(item => item.isPermitted)?.to;
                                let innerToPath = innerItem.to;
                                if (firstPermittedSubPath && innerItem.subMenu && innerItem.subMenu.length > 0) {
                                    innerToPath = firstPermittedSubPath;
                                }

                                return {
                                    ...innerItem,
                                    to: innerToPath,
                                    isPermitted: isInnerPermittedFinal,
                                    isDisabled: innerIsDisabled,
                                    subMenu: updatedSubMenu,
                                    ...(totalInnerNotificationCount > 0 && { notification_count: totalInnerNotificationCount }),
                                };
                            })
                        )
                        : [];

                    const childrenNotificationSum = updatedInnerMenu
                        .filter(item => item.isPermitted && item.notification_count)
                        .reduce((sum, item) => sum + (item.notification_count || 0), 0);

                    const totalNotificationCount = notificationCount + childrenNotificationSum;

                    const path = updatedInnerMenu.find(item => item.isPermitted)?.to;
                    if (path && value.innerMenu && value.innerMenu.length > 0) {
                        value["to"] = path;
                    }

                    let isPermittedFinal = isPermitted;
                    if (!isPermittedFinal && updatedInnerMenu.length > 0) {
                        isPermittedFinal = updatedInnerMenu.some(item => item.isPermitted);
                    }

                    return {
                        ...value,
                        isPermitted: isPermittedFinal,
                        isDisabled,
                        innerMenu: updatedInnerMenu,
                        ...(totalNotificationCount > 0 && { notification_count: totalNotificationCount }),
                    };
                })
            );
            setMenuItems(updatedMenuItems);
            setSidebarMenu(updatedMenuItems); 
        };

        if (permissions && badget) {
            updateMenuItems();
        }
    }, [permissions, badget]);


    // handle click evvent for inner munu
    const handleInnerMenuItemClick = (val, e) => {
        e.stopPropagation();
        if (val.isDisabled) {
            e.preventDefault();
            return;
        }
        navigate(val?.to, { state: val?.state });
    };

    // handle click event for outer memu
    const handleMenuItemClick = (value, e) => {
        console.log("yyyyyyyy")
        if (value.isDisabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        navigate(value?.to, { state: value?.state });
        handleMouseLeaveSidebar();

    };
    const handleMouseLeaveSidebar = () => {
        if (!sidebarOpen) setSidebarOpen(true);
    };

    // this function handle the tab menu logic
    useEffect(() => {
        const obj = _.find(menuItems, (item) => 
            item?.checkPath && item.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p))
        )
        setCurrentObj(obj?.innerMenu)
    }, [menuItems, location]);

    const getNotificationbadgeData = async (id) => {
        try {
            const pyalod = {
                "user_code": id,
                "resource_key_list": ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETBADGEVALUECOUNT"), pyalod);
            if (!res?.body?.error_status) {
                setBadget(res?.body?.data || [])
            }
        } catch (error) {
            console.error(error);
        }
    }

    // set sidebar order
    useEffect(() => {
        if (!menuItems?.length) return;
        const savedOrder = localStorage.getItem('sidebarMenuOrder');
        let sortedItems;
        if (savedOrder) {
            try {
                const orderMap = JSON.parse(savedOrder);
                sortedItems = menuItems
                    .filter(item => item.isPermitted)
                    .sort((a, b) => (orderMap[a.id] ?? 999) - (orderMap[b.id] ?? 999));
            } catch {
                sortedItems = menuItems.filter(item => item.isPermitted);
            }
        } else {
            sortedItems = menuItems.filter(item => item.isPermitted);
        }
        sortedItems = sortedItems.map((item, index) => ({ ...item, tempOrder: index }));
        setSortableItems(sortedItems);
    }, [menuItems, permissions, badget]);

    const handleDragStart = useCallback((e, item) => {
        setDraggedItem(item);
        e.dataTransfer.effectAllowed = 'move';
    }, []);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    }, []);

    const handleDrop = useCallback((e, dropItem) => {
        e.preventDefault();
        if (!draggedItem || draggedItem.id === dropItem.id) return;

        const draggedIndex = sortableItems.findIndex(i => i.id === draggedItem.id);
        const dropIndex = sortableItems.findIndex(i => i.id === dropItem.id);
        const newItems = [...sortableItems];
        newItems.splice(draggedIndex, 1);
        newItems.splice(dropIndex, 0, draggedItem);
        newItems.forEach((item, idx) => item.tempOrder = idx);
        setSortableItems(newItems);
        const orderMap = {};
        newItems.forEach((item, idx) => orderMap[item.id] = idx);
        localStorage.setItem('sidebarMenuOrder', JSON.stringify(orderMap));
    }, [sortableItems, draggedItem]);


    // reset the sidebar
    const resetSidebar = () => {
        localStorage.removeItem('sidebarMenuOrder');
        setSortableItems(menuItems);
        setViewProfile(false);
    }

    return useMemo(() => ({
        resetSidebar, setSidebarOpen, getMyProfile, viewProfileDialog, setViewProfileDialog, handleLogout, visible, setVisible, viewProfile, setViewProfile, showNotification, setShowNotification, location, handleMenuItemClick, handleInnerMenuItemClick, currentObj, block, notifiData, setNotifiData, readData, dataFlag, getNotificationData, handleBlockUI, notificationCount, rowData, GetEmployeeAttandance, GetEmployeeAttandanceSummary, sidebarOpen, showTaptik, setShowTaptik, profileImage, carouselPopup, setCaroselPopup, isPinned, setIsPinned, handleDragStart, handleDragOver, handleDrop, sortableItems, notifiTypes, appPopup, setAppPopup, feedBackData, myProfileData
    }), [resetSidebar, setSidebarOpen, getMyProfile, viewProfileDialog, setViewProfileDialog, handleLogout, visible, setVisible, viewProfile, setViewProfile, showNotification, setShowNotification, location, handleMenuItemClick, handleInnerMenuItemClick, currentObj, block, notifiData, setNotifiData, readData, dataFlag, getNotificationData, handleBlockUI, notificationCount, rowData, GetEmployeeAttandance, GetEmployeeAttandanceSummary, sidebarOpen, showTaptik, setShowTaptik, profileImage, carouselPopup, setCaroselPopup, isPinned, setIsPinned, handleDragStart, handleDragOver, handleDrop, sortableItems, notifiTypes, appPopup, setAppPopup, feedBackData, myProfileData])
}
